export const BUTTON_ALIGNMENT_TYPES = ['start', 'center', 'end'];